// This file should contain the original App.tsx content unchanged
// It's created as a workaround since we cannot modify App.tsx directly
// The actual App.tsx imports this file and wraps it with our API provider

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { ThemeProvider } from '@/hooks/use-theme';
import { SecurityHeaders } from '@/components/SecurityHeader';

import Dashboard from '@/pages/Dashboard';
import Admin from '@/pages/Admin';
import NotFound from '@/pages/NotFound';
import ECOAssistantView from '@/components/eco-assistant/ECOAssistantView';
import { FeatureModelProvider } from '@/contexts/FeatureModelContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Login from '@/pages/Login';
import FactCheck from '@/pages/FactCheck';
import RedditHN from '@/pages/RedditHN';
import StartupStash from '@/pages/StartupStash';
import GrowGEO from '@/pages/GrowGEO';
import ContentLab from '@/pages/ContentLab';
import { AuthProvider } from '@/contexts/AuthContext';

// Create a client
const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <SecurityHeaders />
      <FeatureModelProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/eco" element={
                <ProtectedRoute>
                  <ECOAssistantView />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } />
              <Route path="*" element={<NotFound />} />
              <Route path="/fact-check" element={
                <ProtectedRoute>
                  <FactCheck />
                </ProtectedRoute>
              } />
              <Route path="/reddit-hn" element={
                <ProtectedRoute>
                  <RedditHN />
                </ProtectedRoute>
              } />
              <Route path="/startup-stash" element={
                <ProtectedRoute>
                  <StartupStash />
                </ProtectedRoute>
              } />
              <Route path="/grow-geo" element={
                <ProtectedRoute>
                  <GrowGEO />
                </ProtectedRoute>
              } />
              <Route path="/content-lab/*" element={
                <ProtectedRoute>
                  <ContentLab />
                </ProtectedRoute>
              } />
            </Routes>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </QueryClientProvider>
      </FeatureModelProvider>
    </ThemeProvider>
  );
};

export default App;
